import React, { useRef } from "react";
import { MenuDownIcon } from "assests/GmsIcons";
import DatePicker from 'react-datepicker';
import { formatDateForDisplay } from "./Helpers";

const DateRangePicker = ({
    fromDate,
    toDate,
    onFromDateChange,
    onToDateChange,
    fromDateClassName = "",
    toDateClassName = ""
}: {
    fromDate: Date | null;
    toDate: Date | null;
    onFromDateChange: (date: Date | null) => void;
    onToDateChange: (date: Date | null) => void;
    fromDateClassName?: string;
    toDateClassName?: string;
}) => {
    const fromDatePickerRef = useRef<HTMLDivElement>(null);
    const toDatePickerRef = useRef<HTMLDivElement>(null);

    return (
        <div className="tw-mt-4">
            <div className="tw-flex tw-justify-start tw-gap-6">
                <div>
                    <div className="tw-text-gray-400 tw-text-xs tw-font-semibold tw-mb-2">From</div>
                    <div className="tw-relative" ref={fromDatePickerRef}>
                        <DatePicker
                            selected={fromDate}
                            onChange={(date) => {
                                onFromDateChange(date);
                                if (toDate && date && date > toDate) {
                                    onToDateChange(date);
                                }
                            }}
                            selectsStart
                            startDate={fromDate}
                            endDate={toDate}
                            maxDate={new Date()}
                            dateFormat="MMMM d, yyyy"
                            placeholderText="Select"
                            className={`tw-w-24 tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-outline tw-outline-1 tw-outline-offset-[-1px] ${fromDateClassName || "tw-outline-gray-200"} tw-inline-flex tw-justify-start tw-items-center tw-gap-2.5 tw-text-blue-950 tw-text-sm tw-font-semibold tw-cursor-pointer`}
                            calendarClassName="tw-shadow-[0px_2px_4px_0px_rgba(0,0,0,0.25)] custom-calendar"
                            showPopperArrow={false}
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={15}
                            scrollableYearDropdown
                            customInput={
                                <div className="tw-w-full tw-min-w-[120px] tw-pl-2 tw-inline-flex tw-justify-between tw-items-center">
                                    <div className="tw-flex-1">
                                        {fromDate ? formatDateForDisplay(fromDate) : "Select"}
                                    </div>
                                    <MenuDownIcon />
                                </div>
                            }
                        />
                    </div>
                </div>

                <div>
                    <div className="tw-text-gray-400 tw-text-xs tw-font-semibold tw-mb-2">To</div>
                    <div className="tw-relative" ref={toDatePickerRef}>
                        <DatePicker
                            selected={toDate}
                            onChange={(date) => onToDateChange(date)}
                            selectsEnd
                            startDate={fromDate}
                            endDate={toDate}
                            minDate={fromDate}
                            maxDate={new Date()}
                            dateFormat="MMMM d, yyyy"
                            placeholderText="Select"
                            className={`tw-w-24 tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-outline tw-outline-1 tw-outline-offset-[-1px] ${toDateClassName || "tw-outline-gray-200"} tw-inline-flex tw-justify-start tw-items-center tw-gap-2.5 tw-text-blue-950 tw-text-sm tw-font-semibold tw-cursor-pointer`}
                            calendarClassName="tw-shadow-[0px_2px_4px_0px_rgba(0,0,0,0.25)] custom-calendar"
                            showPopperArrow={false}
                            popperPlacement="bottom-end"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={15}
                            scrollableYearDropdown
                            customInput={
                                <div className="tw-w-full tw-min-w-[120px] tw-inline-flex tw-justify-between tw-items-center">
                                    <div className="tw-flex-1">
                                        {toDate ? formatDateForDisplay(toDate) : "Select"}
                                    </div>
                                    <MenuDownIcon />
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default DateRangePicker;